import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { computed } from "@vue/composition-api";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
export const useLiabilityFieldVisibility = options => {
  const {
    computeSchemaVisibility,
    computeTogglerVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentLiabilityPath = computed(() => {
    return `${currentApplicantPath.value}[liabilities][${options.liabilityIndex.value}]`;
  });
  const currentLiabilityVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = currentLiabilityPath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const isApplicantVisibleFromFillOut = computed(() => {
    var _options$applicantId;
    return computeFillOutVisibility(APPLICATION_STEPS.LIABILITIES, {
      applicantId: (_options$applicantId = options.applicantId) == null ? void 0 : _options$applicantId.value
    }).value;
  });
  const liabilityTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentLiabilityVisibilityPath.value + "[type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const liabilityLimitVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentLiabilityVisibilityPath.value + "[limit]");
    const visibleFromToggler = computeTogglerVisibility(currentLiabilityPath.value + "[limit]", [currentLiabilityPath.value + "[type]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const liabilityBalanceVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentLiabilityVisibilityPath.value + "[balance]");
    return visibleFromSchema.value;
  });
  const liabilityPaymentVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentLiabilityVisibilityPath.value + "[payment]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const liabilityMaturityDateVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentLiabilityVisibilityPath.value + "[maturity-date]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const liabilityPayoffVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentLiabilityVisibilityPath.value + "[payoff]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const liabilityDescriptionVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentLiabilityVisibilityPath.value + "[description]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const isLiabilitySectionVisibleForApplicant = computed(() => {
    return liabilityTypeVisible.value || liabilityLimitVisible.value || liabilityBalanceVisible.value || liabilityPaymentVisible.value || liabilityMaturityDateVisible.value || liabilityPayoffVisible.value || liabilityDescriptionVisible.value;
  });
  return {
    liabilityTypeVisible,
    liabilityLimitVisible,
    liabilityBalanceVisible,
    liabilityPaymentVisible,
    liabilityMaturityDateVisible,
    liabilityPayoffVisible,
    liabilityDescriptionVisible,
    isLiabilitySectionVisibleForApplicant
  };
};